/**
 * Dynamic Slide Color Scheme Handler
 * Updates navigation and dot colors based on the active slide's color scheme
 */

class SlideColorSchemeHandler {
  constructor() {
    this.init();
  }

  init() {
    this.setupSlideChangeListener();
    this.updateColorsForActiveSlide(); // Initial setup
  }

  setupSlideChangeListener() {
    // Listen for Flickity slide changes (banner-slider)
    const sliders = document.querySelectorAll('.slideshow .flickity-enabled');
    
    sliders.forEach(slider => {
      const flickityInstance = Flickity.data(slider);
      if (flickityInstance) {
        flickityInstance.on('change', (index) => {
          this.updateColorsForActiveSlide();
        });
      }
    });

    // Listen for image-hero slide changes
    const imageHeroContainers = document.querySelectorAll('.img-hero');
    imageHeroContainers.forEach(container => {
      // Listen for custom slide change events if they exist
      container.addEventListener('slideChange', () => {
        this.updateColorsForActiveSlide();
      });
    });

    // Use MutationObserver to detect class changes on img-hero slides
    const imageHeroSlides = document.querySelectorAll('.img-hero__slide');
    if (imageHeroSlides.length > 0) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (mutation.target.classList.contains('img-hero__slide--active')) {
              this.updateColorsForActiveSlide();
            }
          }
        });
      });

      imageHeroSlides.forEach(slide => {
        observer.observe(slide, { 
          attributes: true, 
          attributeFilter: ['class'] 
        });
      });
    }

    // Initial update
    this.updateColorsForActiveSlide();
  }

  updateColorsForActiveSlide() {
    // Find the active slide (works for both banner-slider and image-hero)
    const activeSlide = document.querySelector('.slideshow__slide.is-selected') ||
                       document.querySelector('.slideshow__box.is-selected') ||
                       document.querySelector('.slideshow.slideshow--only1') ||
                       document.querySelector('.img-hero__slide--active');

    if (!activeSlide) return;

    // Check if the active slide has light color scheme
    const isLightScheme = activeSlide.classList.contains('slide-color-scheme--light');

    // Update CSS variables on document root
    const root = document.documentElement;
    
    if (isLightScheme) {
      // Use white colors for light backgrounds (needs contrast)
      root.style.setProperty('--slide-text-color', '#ffffff');
      root.style.setProperty('--slide-nav-color', '#ffffff');
      root.style.setProperty('--slide-icon-color', '#ffffff');
      root.style.setProperty('--slide-dot-color', '#ffffff');
      root.style.setProperty('--slide-dot-active-color', '#ffffff');
    } else {
      // Use theme colors for dark backgrounds
      const computedStyles = getComputedStyle(root);
      const themeForeground = computedStyles.getPropertyValue('--color-base-text').trim();
      
      if (themeForeground) {
        root.style.setProperty('--slide-text-color', `rgb(${themeForeground})`);
        root.style.setProperty('--slide-nav-color', `rgb(${themeForeground})`);
        root.style.setProperty('--slide-icon-color', `rgb(${themeForeground})`);
        root.style.setProperty('--slide-dot-color', `rgba(${themeForeground})`);
        root.style.setProperty('--slide-dot-active-color', `rgb(${themeForeground})`);
      } else {
        // Fallback to default theme colors by removing custom properties
        root.style.removeProperty('--slide-text-color');
        root.style.removeProperty('--slide-nav-color');
        root.style.removeProperty('--slide-icon-color');
        root.style.removeProperty('--slide-dot-color');
        root.style.removeProperty('--slide-dot-active-color');
      }
    }

    // Update body class for additional styling if needed
    document.body.classList.toggle('active-slide-light', isLightScheme);
    
    // Update header section class for logo switching
    const headerSection = document.querySelector('#shopify-section-header');
    if (headerSection) {
      headerSection.classList.toggle('active-slide-light', isLightScheme);
    }
  }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Wait a bit for Flickity to initialize
  setTimeout(() => {
    new SlideColorSchemeHandler();
  }, 100);
});

// Also initialize if the script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      new SlideColorSchemeHandler();
    }, 100);
  });
} else {
  setTimeout(() => {
    new SlideColorSchemeHandler();
  }, 100);
}